__webpack_require__.p = "/swarajya/assets/";